// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"94":"49052f73","2313":"c260d704","2490":"fa04f40b","2962":"94f365c4","5418":"c96d7b80","9086":"c7d2b47f"}[chunkId] + ".css";
};